import { PageHeader } from "../components/pages/PageHeader";
import { Instructions } from "../components/pages/dashboard/variables/Instructions";
import { Card } from "../components/ui/Card";
import { VariableForms } from "../components/pages/dashboard/variables/VariableForms";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/Button";

interface VariablesInputPage {
  labTypeSubscriptions: string[];
  wetlabVariables?: unknown;
  drylabVariables?: unknown;
}

export const VariablesInputPage = ({
  labTypeSubscriptions,
}: VariablesInputPage) => {
  const navigate = useNavigate();

  return (
    <div className="l0-layout">
      <PageHeader
        adminGuidePath="/admin-guide"
        backButton={
          <Button
            variant="neutral"
            small
            onClick={() => {
              navigate(-1);
            }}
          >
            Back to dashboard
          </Button>
        }
        pageTitle={"Admin - Variables Input"}
        labTypeSubscriptions={labTypeSubscriptions}
      />
      <Card variant="primary" className={"mt-8"}>
        <div className={"card-body"}>
          <Instructions />
          <div className={"flex gap-8 flex-wrap"}>
            {labTypeSubscriptions.includes("wet") && (
              <VariableForms title={"Wet Lab Variables"} labType={"wet"} />
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};
